import { checkRole, findServiceArea, getAddressDetails, spaceTypeList } from './../../../utils/utils.common';
import { Component, OnInit, Input, Output, EventEmitter, ElementRef, OnChanges, SimpleChanges, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, AbstractControl } from '@angular/forms';
import { Observable, Subject, forkJoin } from 'rxjs';
import { sweetAlert } from 'src/app/utils/swal';
import { Router, ActivatedRoute } from '@angular/router';
import { getBrokersList, getstandingOrderDays } from '../../../utils/utils.common';
import * as moment from 'moment-timezone';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { AssigTripsService } from '../assigntrips-service/assigntrips-service';
// import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { KeyValue } from '@angular/common';
import { debounceTime, distinctUntilChanged, switchMap, takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
// import { ProTipsServiceService } from '../../helping-material/nemt-pro-tips/service/pro-tips-service.service';
import { imageProcessing } from 'src/app/utils/image-processing-utils';
import { ToastrService } from 'ngx-toastr';
// import { TripPurposesService } from '../../trip-purposes/service/trip-purposes.service';
// import { MemberService } from '../../members/member-service/member.service';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { CompaniesService } from '../../companies/service/companies.service';
import { AuthService } from 'src/app/service/auth-service/auth.service';
import { DriversService } from 'src/app/service/drivers-service/drivers-service';
// import { ModifierCodesService } from '../../modifier-codes/modifier-codes-service/modifier-codes.service';
// import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
// import { PrimaryDiagnosisService } from '../../primary-diagnosis/primary-diagnosis-service/primary-diagnosis.service';
// import { EquipmentService } from '../../equipments/equipment-service/equipment.service';
// import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';

@Component({
  selector: 'app-new-trip',
  templateUrl: './new-trip.component.html',
  styleUrls: ['./new-trip.component.css']
})
export class NewTripComponent implements OnInit, OnDestroy {
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  @Input('editId') editId;
  @Output() onUpdate = new EventEmitter<string>();

  newTripForm: FormGroup;
  addonsServicesForm: FormGroup;
  timeZone = "America/New_York";
  todayDate = moment().tz(this.timeZone);
  user;
  memberList = [];
  fundingSourceList = [];
  tripPurposeList = [];
  modifierList = [];
  levelOfServiceList = [];
  spaceTypeList = [];
  spaceTypeMainList = [];
  serviceAreaList = [];
  primaryDiagnoseList = [];
  addonsList = [];
  filteredAddonsList = [];
  driverList = [];
  isAllowRates = false;
  tripId;
  submitted = false;
  addMemberModalObj;
  addressPickerObj;

  // selectedCompanyId = "";
  companiesList:any;
  selectedCompany: any = "";

  preLevelOfServices = {};
  preSpaceTypes = {};
  preServiceAreas = {};
  companyToken = '';
  routeData;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private socketService: SocketService,
    private sharedDataService: SharedDataService,
    private assignTripService: AssigTripsService,
    private toastr: ToastrService,
    private corporateService: CorporateService,
    private companyService : CompaniesService,
    private authService: AuthService,
    private driverService: DriversService,
  ) {
    this.routeData = this.router.getCurrentNavigation().extras.state
    if (this.routeData && this.routeData.companyId) {
      this.onReceiveRouteData(this.routeData);
    }
  }

  ngOnInit() {
    if (this.activatedRoute.snapshot.url.length === 3 && this.activatedRoute.snapshot.url[2].path === 'edit') {
      this.tripId = this.activatedRoute.snapshot.url[1].path;
    }


    this.newTripForm = this.fb.group({
      company: ['', Validators.required],

      rawId: [''],
      tripId: [''],
      isMedical: [false], // will remove later
      companyType: [''], // will remove later
      jobType: ['cooperate', Validators.required], // will remove later

      jobDestinationAddress: ['', Validators.required],
      jobDestinationLatitude: [0, Validators.required],
      jobDestinationLongitude: [0, Validators.required],
      zipCodeDest: [''],

      jobOriginAddress: ['', Validators.required],
      jobOriginLatitude: [0, Validators.required],
      jobOriginLongitude: [0, Validators.required],
      zipCodeOrg: [''],

      client: ['', Validators.required],
      los: ['', Validators.required],
      losDetails: [{}, Validators.required],
      spaceType: ['', Validators.required],
      spaceTypeDetails: [{}, Validators.required],

      priorityClient: this.fb.group({
        displayName: ['', Validators.required],
        contactNumber: ['0000000000'],
        cellPhone: [''],
        clientId: [''],
        email: [''],
        preDob: ['', this.dobValidator],
        dob: [''],
        weight: [''],
        gender: ['']
      }),

      originAddressAdditional: this.fb.group({
        modifier: [''],
        modifierTwo: [''],
        floor: [''],
        room: [''],
        aptOrSuite: [''],
        place: [''],
        phone: ['']
      }),
      destinationAddressAdditional: this.fb.group({
        modifier: [''],
        modifierTwo: [''],
        floor: [''],
        room: [''],
        aptOrSuite: [''],
        place: [''],
        phone: ['']
      }),

      cooperate: ['', Validators.required],
      cooperateDetails: [{}],

      preScheduleTime: ["", Validators.required],
      preAppointmentTime: ["", Validators.required],
      appointmentTime: ["", Validators.required],
      scheduleTime: ["", Validators.required],

      milage: [null],
      tripLegs: this.fb.array([]),
      addonServices: this.fb.array([]),
      noOfEscorts: [''],
      tripReason: [[]],
      ipa: [''],
      primaryDiagnosis: [''],
      companyNote: [''],
      dispatchNoteTwo: [''],
      attachment: [''],

      status: [''],
      jobStatus: [''],
      driver: [null],
      events: [[]],
      serviceArea: [''],
      serviceAreaDest: [''],
      // Local Variable
      estimateFare: [{ value: '', disabled: true }],
      isVipTrip: [false],
      isConfirmedTrip: [false],
      isMethadone: [false],
      authorizationNumber: [''],
    });


    if (this.editId) {
      this.tripId = this.editId;
    }

    // this.makeCompulsoryCalls();
    this.getCompaniesList();
  }

  onChangeCompany(event) {
    this.companyToken = '';
    if(event){
      this.selectedCompany = event;
      this.getCompanyToken();
      // this.makeCompulsoryCalls();
    }
  }

  onReceiveRouteData(data) {
    // this.selectedCompanyId = data.companyId;
    this.companyToken = data.companyToken;
    this.selectedCompany = data.companyId;
    // this.makeCompulsoryCalls();
    this.getCompanyToken()
  }

  getCompanyToken(): any {
    if (!this.selectedCompany) {
      return;
    }
    this.companyService.getCompanyToken(this.selectedCompany)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe((data: any) => {
      this.companyToken = data.companyToken;
      this.authService.setToken(data.companyToken,'providerToken');
      // this.getAllTrips();
      this.makeCompulsoryCalls();
    })
  }

  getConfigurations() {
    return this.assignTripService.getConfigurations();
  }

  getCompaniesList() {
    const queryParams = {
      accountStatus: 'active',
      isRemoveIAAL: false
    }

    this.companyService.getCompanies(queryParams)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe((data) => {
      if (data) {
        this.companiesList = data;

      }
    });
  }



  makeCompulsoryCalls() {
    const requests = [
      this.getConfigurations()
      // this.getLevelOfService(),
      // this.getSpaceTypeList(),
    ];

    // Make all requests in parallel
    forkJoin(requests).subscribe(
      ([res1]) => {
        if (res1) {
          this.preLevelOfServices = res1.levelofservices.reduce((obj, item) => (obj[item._id] = item, obj), {});;
          this.levelOfServiceList = res1.levelofservices
          
          this.preSpaceTypes = res1.spacetypes.reduce((obj, item) => (obj[item._id] = item, obj), {});;
          this.spaceTypeMainList = res1.spacetypes;

          this.preServiceAreas = res1.serviceareas.reduce((obj, item) => (obj[item._id] = item, obj), {});
          this.serviceAreaList = res1.serviceareas;

          this.fundingSourceList = res1.cooperates;
          this.getMemberList();
        }

        // if (res1) {
        //   this.levelOfServiceList = res1;
        // }
        // if (res2) {
        //   this.spaceTypeMainList = res2;
        // }

        
        this.getTripPurposeList();
        // this.getFundingSourceList(); from configurations
        this.getModifierList();
        this.getPrimaryDiagnoseList();
        // this.getAddonsList();
        this.getUser();
        this.getDriverList();
        // this.getServiceAreaList();
      },
      error => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = this.user.timeZone;
          this.todayDate = moment().tz(this.timeZone);

          this.newTripForm.patchValue({
            company: this.user._id,

            preScheduleTime: this.todayDate,
            scheduleTime: this.todayDate.toISOString(),

            preAppointmentTime: moment(this.todayDate).add(1, 'hours'),
            appointmentTime: moment(this.todayDate).add(1, 'hours').toISOString(),
          });


          if (this.tripId) {
            this.getTripDetails();
          }

          this.isAllowRates = checkRole(this.user);
        }
      });
  }

  getTripDetails() {
    this.assignTripService
      .getUnassignedTripDetailById(this.tripId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          const preData = JSON.parse(JSON.stringify(data));
          // remove standing order
          delete preData.addonServices;

          this.newTripForm.patchValue({
            ...preData,
            preScheduleTime: moment(preData.scheduleTime).tz(this.timeZone),
            preAppointmentTime: moment(preData.appointmentTime).tz(this.timeZone),
            preRecurringEndDate: preData.recurringEndDate ? moment(preData.recurringEndDate).tz(this.timeZone) : null,
            priorityClient: {
              ...preData.priorityClient,
              preDob: preData.priorityClient && preData.priorityClient.dob ? moment(preData.priorityClient.dob).tz(this.timeZone).format('MM/DD/YYYY') : '',
          }
          });
          this.onSelectLOS(data.los);

          if (data.cooperate) {
            this.getAddonsList(data.cooperate);
          }

          if (data.addonServices) {
            this.addAddonsItem(data.addonServices)
          }
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }

  getMemberList() {
    // memberService
    this.assignTripService
      .getMembers()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.memberList = data;
        }
      });
  }

  getTripPurposeList() {
    // tripPurposesService
    this.assignTripService
      .getTripPurposesList('active')
      .subscribe(data => {
        if (data) {
          this.tripPurposeList = data;
        }
      });
  }

  getFundingSourceList() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.fundingSourceList = data;
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getModifierList() {
    // modifierCodesService
    this.assignTripService
      .getModifierCodes()
      .subscribe(data => {
        if (data) {
          this.modifierList = data;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getLevelOfService() {
    // levelOfServiceService
    return this.assignTripService.getLevelOfServices({ status: 'active' });
  }

  getSpaceTypeList() {
    // levelOfServiceService
    return this.assignTripService.getSpaceTypes({ status: 'active' });
  }

  getPrimaryDiagnoseList() {
    // primaryDiagnosisService
    this.assignTripService
      .getPrimaryDiagnosis()
      .subscribe(data => {
        if (data) {
          this.primaryDiagnoseList = data;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getAddonsList(fundingSourceId) {
    //add params to send the cooperate key in the equipment api
    let queryParams = {
      isAddon: true,
      cooperate: fundingSourceId
    }
    // equipmentService
    this.assignTripService
      .getEquipments(queryParams)
      .subscribe(data => {
        if (data) {
          this.addonsList = data;
          this.filteredAddonsList = data;
          this.onSelectSpaceType();

        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getDriverList() {
    // driverService
    this.assignTripService
      .getDrivers(this.selectedCompany, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.driverList = data;
        }
      });
  }

  get form() {
    return this.newTripForm.controls;
  }

  get legForm() {
    return this.newTripForm.get('tripLegs') as FormArray;
  }

  addLegItem() {
    const items = this.newTripForm.get('tripLegs') as FormArray;
    let preValues;
    if (items.length === 0) {
      preValues = this.newTripForm.value
    } else {
      preValues = items.at(items.length - 1).value;
    }

    let hour = items.length === 0 ? 1 : 2;
    // if (!items.invalid) {
    items.push(
      this.fb.group({
        jobDestinationAddress: [preValues.jobOriginAddress, Validators.required],
        jobDestinationLatitude: [preValues.jobOriginLatitude, Validators.required],
        jobDestinationLongitude: [preValues.jobOriginLongitude, Validators.required],
        zipCodeDest: [preValues.zipCodeOrg],
        serviceAreaDest: [preValues.serviceArea],

        jobOriginAddress: [preValues.jobDestinationAddress, Validators.required],
        jobOriginLatitude: [preValues.jobDestinationLatitude, Validators.required],
        jobOriginLongitude: [preValues.jobDestinationLongitude, Validators.required],
        zipCodeOrg: [preValues.zipCodeDest],
        serviceArea: [preValues.serviceAreaDest],

        preScheduleTime: [moment(preValues.preAppointmentTime).add(hour, 'hours'), Validators.required],
        scheduleTime: [moment(preValues.preAppointmentTime).add(hour, 'hours').toISOString(), Validators.required],
        preAppointmentTime: [moment(preValues.preAppointmentTime).add(hour, 'hours'), Validators.required],
        companyNote: [''],
        isWillCall: [false],

        originAddressAdditional: this.fb.group({
          modifier: [preValues.destinationAddressAdditional.modifier],
          modifierTwo: [preValues.destinationAddressAdditional.modifierTwo],
          floor: [preValues.destinationAddressAdditional.floor],
          room: [preValues.destinationAddressAdditional.room],
          aptOrSuite: [preValues.destinationAddressAdditional.aptOrSuite],
          place: [preValues.destinationAddressAdditional.place],
          phone: [preValues.destinationAddressAdditional.phone]
        }),
        destinationAddressAdditional: this.fb.group({
          modifier: [preValues.originAddressAdditional.modifier],
          modifierTwo: [preValues.originAddressAdditional.modifierTwo],
          floor: [preValues.originAddressAdditional.floor],
          room: [preValues.originAddressAdditional.room],
          aptOrSuite: [preValues.originAddressAdditional.aptOrSuite],
          place: [preValues.originAddressAdditional.place],
          phone: [preValues.originAddressAdditional.phone]
        }),


      })
    );
    // }
  }

  removeLegItem(index: any) {
    const items = this.newTripForm.get('tripLegs') as FormArray;
    items.removeAt(index);
  }

  get addonsForm() {
    return this.newTripForm.get('addonServices') as FormArray;
  }

  addAddonsItem(preAddonList?) {
    const items = this.newTripForm.get('addonServices') as FormArray;

    if (preAddonList) {
      for (const addon of preAddonList) {
        items.push(
          this.fb.group({
            addonId: [addon.addonId, Validators.required],
            quantity: [addon.quantity, [Validators.required, Validators.min(1)]],
            title: [addon.title],
            fare: [addon.fare],
            code: [addon.code],
            total: [addon.total]
          })
        );

      }
      return;
    }

    // if (!items.invalid) {
    items.push(
      this.fb.group({
        addonId: ['', Validators.required],
        quantity: [1, [Validators.required, Validators.min(1)]],
        title: [''],
        fare: [0],
        code: [0],
        total: [0]
      })
    );
    // }
  }

  removeAddonsItem(index: any) {
    const items = this.newTripForm.get('addonServices') as FormArray;
    items.removeAt(index);
  }


  onSelectMember(event) {
    let member;
    if (event) {
      member = this.memberList.find((member) => member._id === event);
    }
    this.setMemberDetails(member);
  }

  setMemberDetails(member) {
    try {
      if (member) {
        let memberPayload;
        memberPayload = {
          priorityClient: member,
          isVipTrip: member.type === "vip" ? true : false,
          originAddressAdditional: {
            phone: member.contactNumber,
            dispatchNoteTwo: member.note + " ----------  " + member.privateNote,
          }
        }

        if (member.homeAddress && member.homeAddress.address) {
          memberPayload = {
            ...memberPayload, jobOriginAddress: member.homeAddress.address,
            jobOriginLatitude: member.homeAddress.latitude,
            jobOriginLongitude: member.homeAddress.longitude,
            zipCodeOrg: member.homeAddress.zipCode
          };
        }

        if (member.homeAddress && member.homeAddress.name) {
          memberPayload = {
            ...memberPayload,
            originAddressAdditional: {
              ...memberPayload.originAddressAdditional,
              place: member.homeAddress.name,
            }
          };
        }

        if (member.fundingSource) {
          memberPayload = { ...memberPayload, cooperate: member.fundingSource };
        }

        if (member.spaceType) {
          memberPayload = { ...memberPayload, spaceType: member.spaceType };
        }
        if (member.dob) {
          memberPayload = {
            ...memberPayload,
            priorityClient:{
              ...memberPayload.priorityClient,
              preDob: moment(member.dob).format('MM/DD/YYYY'),
              dob: member.dob
            }

          };

        }

        this.newTripForm.patchValue(memberPayload);

        if (member.los) {
          this.newTripForm.patchValue({
            los: member.los
          });
          this.onSelectLOS(member.los);
        }

      } else {
        this.newTripForm.patchValue({
          priorityClient: {
            displayName: '',
            contactNumber: '',
            cellPhone: '',
            clientId: '',
            email: '',
            dob: '',
            weight: '',
            gender: ''
          },
        });
      }
    } catch (err) {
      (err);
    }
  }

  setOriginAddress(place, index?) {
    const addressDetails = place ? getAddressDetails(place) : undefined;
    const zip = addressDetails.zipCode;
    const myServiceArea = findServiceArea(zip, this.serviceAreaList);

    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      items.at(index).patchValue({
        jobOriginAddress: place.formatted_address,
        jobOriginLatitude: place.geometry.location.lat(),
        jobOriginLongitude: place.geometry.location.lng(),
        zipCodeOrg: zip,
        serviceArea: myServiceArea
      });
    } else {
      this.newTripForm.patchValue({
        jobOriginAddress: place.formatted_address,
        jobOriginLatitude: place.geometry.location.lat(),
        jobOriginLongitude: place.geometry.location.lng(),
        zipCodeOrg: zip,
        serviceArea: myServiceArea
      });
    }
  }

  setDestinationAddress(place, index?) {
    const addressDetails = place ? getAddressDetails(place) : undefined;
    const zip = addressDetails.zipCode;
    const myServiceArea = findServiceArea(zip, this.serviceAreaList);
    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      items.at(index).patchValue({
        jobDestinationAddress: place.formatted_address,
        jobDestinationLatitude: place.geometry.location.lat(),
        jobDestinationLongitude: place.geometry.location.lng(),
        zipCodeDest: zip,
        serviceAreaDest: myServiceArea
      });
    } else {
      this.newTripForm.patchValue({
        jobDestinationAddress: place.formatted_address,
        jobDestinationLatitude: place.geometry.location.lat(),
        jobDestinationLongitude: place.geometry.location.lng(),
        zipCodeDest: zip,
        serviceAreaDest: myServiceArea
      });
    }
  }

  setPickTimeChange(event, index?) {
    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      items.at(index).patchValue({
        scheduleTime: moment(event).tz(this.timeZone, true).toISOString(),
      });

      if (!this.tripId) {
        items.at(index).patchValue({
          preAppointmentTime: moment(event).add(1, 'hours')
        });
      }

    } else {
      this.newTripForm.patchValue({
        scheduleTime: moment(event).tz(this.timeZone, true).toISOString(),
      });

      if (!this.tripId) {
        this.newTripForm.patchValue({
          preAppointmentTime: moment(event).add(1, 'hours')
        });
      }
    }
  }

  setDropOffTimeChange(event, index?) {
    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      items.at(index).patchValue({
        appointmentTime: moment(event).tz(this.timeZone, true).toISOString(),
      });

    } else {
      this.newTripForm.patchValue({
        appointmentTime: moment(event).tz(this.timeZone, true).toISOString(),
      });
    }
  }

  setWillCall(event, index) {
    const items = this.newTripForm.get('tripLegs') as FormArray;

    if (event.target.checked) {
      const time = items.at(index)['controls'].preScheduleTime.value;
      time.set('hour', 22)
      time.set('minute', 0)
      items.at(index)['controls'].preScheduleTime.setValue(time);

      items.at(index)['controls'].preScheduleTime.disable();
    } else {
      items.at(index)['controls'].preScheduleTime.enable();
    }

  }

  onSelectFundingSource(event) {
    this.newTripForm.patchValue({
      cooperateDetails: {
        displayName: '',
        profileImageURL: ''
      }
    });

    const fundingSource = this.fundingSourceList.find((fundingSource) => fundingSource._id === event);
    if (fundingSource) {
      this.newTripForm.patchValue({
        cooperateDetails: {
          displayName: fundingSource.displayName,
          profileImageURL: fundingSource.profileImageURL
        }
      });
      //Additional Code removed, clearing the array on change of funding source
      this.getAddonsList(fundingSource._id);

    }
    const addonServices = this.newTripForm.get('addonServices') as FormArray;
    // addonServices.clear();
  }

  onSelectLOS(losId) {
    this.spaceTypeList = [];
    if (!losId) {
      this.newTripForm.patchValue({
        spaceType: ''
      });
      return;
    };

    this.spaceTypeList = this.spaceTypeMainList.filter(item => item.los === losId);
    const spaceTypes = this.spaceTypeList.filter(spaceTypeItem => spaceTypeItem._id === this.newTripForm.value.spaceType);
    if (!spaceTypes.length) {
      this.newTripForm.patchValue({
        spaceType: '',
      });
    }
  }
  onSelectSpaceType() {
    const addonServices = this.newTripForm.get('addonServices') as FormArray;
    // addonServices.clear();
    this.filteredAddonsList = this.addonsList.filter(item => item.spaceType === this.newTripForm.value.spaceType)
  }


  onSelectAddonItem(addonItem) {
    if (!addonItem.value.addonId || !addonItem.value.quantity) return;

    const item = this.addonsList.find(item => item._id === addonItem.value.addonId);
    addonItem.patchValue({
      ...item,
      total: item.fare * addonItem.value.quantity
    });
  }

  async fileProcessing(ImageInput, form) {
    imageProcessing(ImageInput)
      .subscribe(async (result) => {
        // proTipsService
        const data: any = await this.assignTripService.changeCoverImage(result.file).toPromise();
        form.setValue(data.location);
      })
  }

  removeFile() {
    this.newTripForm.patchValue({ attachment: '' });
    this.fileInput.nativeElement.value = '';
  }

  onCreateTrip() {
    this.validateDOB();
    this.submitted = true;
    if (this.newTripForm.invalid) return;

    if (!this.newTripForm.value.priorityClient.contactNumber) {
      this.newTripForm.controls.priorityClient.patchValue({
        contactNumber: '0000000000'
      })
    }

 

    let payload = this.newTripForm.value;
    if (!payload.status || !payload.jobStatus) {
      delete payload.status;
      delete payload.jobStatus;
    }
    if (!payload.originAddressAdditional.modifier) {
      payload.originAddressAdditional.modifier = null
    }

    if (!payload.destinationAddressAdditional.modifier) {
      payload.destinationAddressAdditional.modifier = null
    }
    if (!payload.serviceArea) {
       payload.serviceArea = null;
    }
    if (!payload.serviceAreaDest) {
       payload.serviceAreaDest = null;
    }

    for (let leg of payload.tripLegs) {
      if (!leg.originAddressAdditional.modifier) {
        leg.originAddressAdditional.modifier = null
      }

      if (!leg.destinationAddressAdditional.modifier) {
        leg.destinationAddressAdditional.modifier = null
      }
      if (!leg.serviceArea) {
        leg.serviceArea = null
      }
      if (!leg.serviceAreaDest) {
        leg.serviceAreaDest = null
      }
    }


    this.assignTripService
      .createNewTripV2(payload, this.tripId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          if (this.editId) {
            this.onUpdate.emit(data);
          } else {
            this.router.navigateByUrl('dashboard');
          }
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });

  }

  openAddMemberModal() {
    this.addMemberModalObj = true;
  }

  onSaveMember(evt) {
    if (evt && this.memberList && this.memberList.length) {
      // Update existing member in the list
      const index = this.memberList.findIndex(member => member._id === evt._id);
      if (index !== -1) {
        this.memberList[index] = evt; // Update existing member
        this.memberList = [...this.memberList];
      } else {
        this.memberList.push(evt); // Add new member if not exists (fallback)
      }
  
      // Update the form with new member details
      this.newTripForm.patchValue({
        client: evt._id
      });
      this.setMemberDetails(evt);
      
      this.addMemberModalObj = false;
  
      // Refresh the dropdown by triggering change detection
    }
  }

  

  

  getServiceAreaList() {
    // serviceArea
    this.assignTripService
      .getServiceAreas({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.serviceAreaList = data;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  calculateEstimatedFare() {
    const { jobOriginLatitude, jobOriginLongitude, jobDestinationLatitude, jobDestinationLongitude, scheduleTime, cooperate, spaceType, milage, addonServices } = this.newTripForm.value;

    if (!jobOriginLatitude || !jobOriginLongitude || !jobDestinationLatitude || !jobDestinationLongitude || !scheduleTime || !cooperate || !spaceType) {
      sweetAlert('Alert', 'Please select Pickup, Drop Off address, Space Type, Pickup Time & Funding Source', 'warning', 'Ok')
      return;
    }

    let payload;

    payload = {
      company: this.user._id,
      jobDestinationLatitude: jobDestinationLatitude,
      jobDestinationLongitude: jobDestinationLongitude,
      jobOriginLatitude: jobOriginLatitude,
      jobOriginLongitude: jobOriginLongitude,
      spaceType: spaceType,
      cooperate: cooperate,
      scheduleTime: scheduleTime
    };

    if (milage) {
      payload.milage = milage;
    }

    if (addonServices && addonServices.length) {
      payload = { ...payload, addonServices: addonServices }
    }

    this.assignTripService
      .calculateEstimateFare(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.newTripForm.patchValue({
            estimateFare: data.totalFare
          })
        }
      });
  }

  loadAddressPicker(title, value, address?, lat?, lng?, zipCode?) {
    this.addressPickerObj = { title, value, address, lat, lng, zipCode };
  }

  onAddressPicker(event) {
    this.addressPickerObj = null;
    const items = this.newTripForm.get('tripLegs') as FormArray;
    if (!event) return;

    // For Pickup Addresss
    if (event.reference.value === '0') {
      this.newTripForm.patchValue({
        jobOriginAddress: event.address,
        jobOriginLatitude: event.lat,
        jobOriginLongitude: event.lng,
        zipCodeOrg: event.zipCode
      });
    } else if (event.reference.value === '1') {
      this.newTripForm.patchValue({
        jobDestinationAddress: event.address,
        jobDestinationLatitude: event.lat,
        jobDestinationLongitude: event.lng,
        zipCodeDest: event.zipCode
      });
    } else if (event.reference.value === '01') {
      items.at(0).patchValue({
        jobOriginAddress: event.address,
        jobOriginLatitude: event.lat,
        jobOriginLongitude: event.lng,
        zipCodeOrg: event.zipCode
      });
    } else if (event.reference.value === '11') {
      items.at(0).patchValue({
        jobDestinationAddress: event.address,
        jobDestinationLatitude: event.lat,
        jobDestinationLongitude: event.lng,
        zipCodeDest: event.zipCode
      });
    } else if (event.reference.value === '02') {
      items.at(1).patchValue({
        jobOriginAddress: event.address,
        jobOriginLatitude: event.lat,
        jobOriginLongitude: event.lng,
        zipCodeOrg: event.zipCode
      });
    } else if (event.reference.value === '12') {
      items.at(1).patchValue({
        jobDestinationAddress: event.address,
        jobDestinationLatitude: event.lat,
        jobDestinationLongitude: event.lng,
        zipCodeDest: event.zipCode
      });
    }

    if (this.newTripForm.value.jobOriginAddress &&
      this.newTripForm.value.jobOriginLatitude &&
      this.newTripForm.value.jobOriginLongitude &&
      this.newTripForm.value.jobDestinationAddress &&
      this.newTripForm.value.jobDestinationLatitude &&
      this.newTripForm.value.jobDestinationLongitude) {
    }
  }

  onDateChange(evt, control: AbstractControl) {
    if (evt) {
      control.setValue(moment(evt).toISOString());
    }
  }

  dobValidator(control: AbstractControl) {
    const dateValue = control.value;
    if (!dateValue) return null;

    const isValidFormat = moment(dateValue, 'MM/DD/YYYY', true).isValid();
    return isValidFormat ? null : { invalidDateFormat: true };
  }

  validateDOB() {
    const control = this.newTripForm.controls.priorityClient.get('preDob');
    if (control && control.valid) {
      const dateValue = moment(control.value, 'MM/DD/YYYY').toISOString();
      this.newTripForm.controls.priorityClient.patchValue({ dob: dateValue }, { emitEvent: false });
    }
  }

  ngOnDestroy(): void {
    localStorage.removeItem('providerToken');
  }
}
